import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import VerificationTemplate from "./VerificationTemplate";
import authService from "../../../service/auth.service";

export default function EmailVerify() {
  const { id, code } = useParams();

  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const runVerification = async () => {
      try {
        const res = await authService.verifyUser(id, code);

        setMsg(res?.message || "");
        setState("success");
      } catch (err) {
        setMsg(err.response?.data?.message || "");
        setState("error");
      }
    };

    runVerification();
  }, [id, code]);

  return <VerificationTemplate state={state} msg={msg} />;
}
